import { translate } from 'utils/translations'
import RegenerateIcon from 'assets/svgr-icons/Regenerate.svg'
import DownloadIcon from 'assets/svgr-icons/Download.svg'
import { T } from 'consts/translationKeys'
import { IAIVideoProject } from 'types/aiVideo'
import { useAddAiItemToTimeline } from 'hooks/useAddAiItemToTimeline'
import { dispatch } from 'store'
import { downloadMedia } from 'utils'
import { TabKey } from 'containers/SubSidebar/AIVideoContent/consts'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { useCallback } from 'react'
import { convertAiVideoToBaseMediaItem } from '../utils'
import { IActionData } from 'common-components/ActionsOverlay/types'

interface IVideoActionsProps {
  video: IAIVideoProject
}

export const useAiVideoActions = ({ video }: IVideoActionsProps) => {
  const addItemToTimeline = useAddAiItemToTimeline()
  const baseMediaItem = convertAiVideoToBaseMediaItem(video)

  const handleAddToTimeline = useCallback(() => {
    addItemToTimeline(baseMediaItem)
  }, [baseMediaItem, addItemToTimeline])

  const handleCreateSimilar = useCallback(() => {
    dispatch(aiVideoThunks.setGenerationParamsByAssetId(video.id))
    dispatch(aiVideoThunks.setActiveTab(TabKey.GENERATE))
  }, [video])

  const handleDownload = useCallback(async () => {
    if (!video?.videoUrl) return

    await downloadMedia({
      filePath: video.videoUrl,
      fileName: `ai-video-${video.id}`
    })
  }, [video.videoUrl, video.id])

  const primaryActions: IActionData[] = [
    {
      key: T.CREATE_SIMILAR,
      title: translate(T.CREATE_SIMILAR),
      icon: <RegenerateIcon />,
      onClick: handleCreateSimilar
    },
    {
      key: T.DOWNLOAD,
      title: translate(T.DOWNLOAD),
      icon: <DownloadIcon />,
      onClick: handleDownload
    }
  ]

  return { mainAction: handleAddToTimeline, primaryActions }
}
